import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';

const LANG_KEY = 'language';
@Injectable({
  providedIn: 'root',
})
export class TranslateConfigService {
  languageCodes = environment.languages
    .filter((p) => p.active == true)
    .map((language) => {
      return language.code;
    });
  constructor(
    private translate: TranslateService,
    private storageService: StorageService
  ) {}

  async getDefaultLanguage(language: string): Promise<string> {
    const data = await this.storageService.get(LANG_KEY);
    if (data && this.languageCodes.includes(data)) {
      this.translate.setDefaultLang(data);
      this.translate.use(data);
      return data;
    } else {
      // get user's browser language
      const browserLang = this.translate.getBrowserLang();
      if (browserLang && this.languageCodes.includes(browserLang)) {
        this.translate.setDefaultLang(browserLang);
        this.translate.use(browserLang);
        return browserLang;
      }

      this.translate.setDefaultLang(language);
      this.translate.use(language);
      return language;
    }
  }

  setLanguage(setLang: string) {
    this.storageService.set(LANG_KEY, setLang).then(() => {
      this.translate.use(setLang);
    });
  }

  getTranslation(str: string) {
    const currentLang = this.translate.currentLang ?? 'en';
    const langTranslations = this.translate.translations[currentLang];
    if (!langTranslations) {
      console.warn(`No translations loaded for ${currentLang}`);
      return str;
    }

    const returnValue = langTranslations[str];

    return returnValue !== undefined ? returnValue : str;
  }

  getTranslationWithParam(string: string, param: any) {
    const stringTranslated = this.translate.instant(string, param);
    return stringTranslated;
  }

  getCurrentLanguage() {
    const language = this.translate.currentLang;
    if (!language) {
      this.setLanguage('en');
      return 'en';
    }

    return language;
  }
}
